

<div class="col-md-10 mx-auto p-2 rounded border">
  <button mat-raised-button type="button"
          class="primary-btn"
          (click)="file.click()">
    <mat-icon svgIcon="image"></mat-icon>
    Choose Image
  </button>
  <input type="file" (change)="fileChangeEvent($event)" #file class="invisible"
         accept="image/png, image/jpeg">
  <image-cropper
    [imageChangedEvent]="imageChangedEvent"
    [aspectRatio]="aspectRatio"
    (imageCropped)="onImageCropped($event)"
    (imageLoaded)="onImageLoaded()"
    (cropperReady)="onCropperReady()"
    output="base64"
    imageQuality="0.7"
    (loadImageFailed)="onLoadImageFailed()">
  </image-cropper>
</div>
